// The browser's built-in PDF viewer (Chrome/Edge) reads PDF Open Parameters
// off the URL fragment - safe to append after a presigned S3 URL's query
// string since fragments never get sent to the server. Used to control the
// initial view without any extra dependency.

// The modal's single-page zoomed view: start noticeably more zoomed in than
// the viewer's own default, so the page is readable without the user having
// to click the zoom-in control themselves.
export function toZoomedPdfUrl(url: string): string {
  return `${url}#zoom=110`;
}
